/**
 * 测试动作预设
 * 
 * 步骤：
 * 1. 将图层一重命名为底图，图层二重命名为全屏水印Q1，图层三重命名为全屏水印Q2
 * 2. 将图层三反转颜色为白色
 * 3. 合并图层二和图层三并将新的图层重命名为调整水印
 * 4. 复制一层调整水印并将复制的图层重命名为调整水印2
 * 5. 选择调整水印2执行反转颜色，并将图层向左上方移动一个像素
 * 6. 合并调整水印层与调整水印2图层并重命名为水印效果
 * 7. 将水印效果的混合模式改为叠加
 */

// 对图层应用反相滤镜
function applyInvertFilter(layerCanvas) {
    if (!layerCanvas) return false;
    
    const ctx = layerCanvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
    const data = imageData.data;
    
    // 反相操作
    for (let i = 0; i < data.length; i += 4) {
      data[i] = 255 - data[i];         // 红
      data[i + 1] = 255 - data[i + 1]; // 绿
      data[i + 2] = 255 - data[i + 2]; // 蓝
      // 不修改 alpha 通道
    }
    
    ctx.putImageData(imageData, 0, 0);
    return true;
  }
  
  // 合并两个图层
  function mergeLayers(context, layer1Index, layer2Index) {
    const { layers, layerCanvases } = context;
    
    // 确保图层索引有效
    if (layer1Index < 0 || layer1Index >= layers.length ||
        layer2Index < 0 || layer2Index >= layers.length) {
      throw new Error('合并图层时索引无效');
    }
    
    // 获取图层画布
    const layer1 = layers[layer1Index];
    const layer2 = layers[layer2Index];
    const canvas1 = layerCanvases[layer1.id];
    const canvas2 = layerCanvases[layer2.id];
    
    if (!canvas1 || !canvas2) {
      throw new Error('无法获取图层画布');
    }
    
    // 创建新的画布
    const mergedCanvas = document.createElement('canvas');
    mergedCanvas.width = canvas1.width;
    mergedCanvas.height = canvas1.height;
    const ctx = mergedCanvas.getContext('2d');
    
    // 先绘制第一个图层
    ctx.drawImage(canvas1, 0, 0);
    
    // 使用第二个图层的混合模式绘制第二个图层
    ctx.globalCompositeOperation = layer2.blendMode;
    ctx.globalAlpha = layer2.opacity / 100;
    ctx.drawImage(canvas2, 0, 0);
    
    // 重置设置
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    
    // 创建新的图层ID
    const newLayerId = Date.now(); // 使用时间戳作为唯一ID
    
    // 创建合并后的图层对象
    const mergedLayer = {
      id: newLayerId,
      name: `合并的图层_${newLayerId}`,
      visible: true,
      opacity: 100,
      blendMode: 'normal',
      filters: {
        blur: 0,
        brightness: 100,
        contrast: 100,
        saturation: 100
      }
    };
    
    // 添加到图层列表
    layers.splice(layer1Index, 1, mergedLayer); // 替换第一个图层
    layers.splice(layer2Index < layer1Index ? layer2Index : layer2Index - 1, 1); // 删除第二个图层
    
    // 保存合并后的画布
    layerCanvases[newLayerId] = mergedCanvas;
    
    return {
      layerIndex: layer1Index,
      layerId: newLayerId
    };
  }
  
  // 复制图层
  function duplicateLayer(context, layerIndex) {
    const { layers, layerCanvases } = context;
    
    // 确保图层索引有效
    if (layerIndex < 0 || layerIndex >= layers.length) {
      throw new Error('复制图层时索引无效');
    }
    
    // 获取原图层
    const sourceLayer = layers[layerIndex];
    const sourceCanvas = layerCanvases[sourceLayer.id];
    
    if (!sourceCanvas) {
      throw new Error('无法获取图层画布');
    }
    
    // 创建新的图层ID
    const newLayerId = Date.now(); // 使用时间戳作为唯一ID
    
    // 复制图层对象
    const duplicatedLayer = {
      id: newLayerId,
      name: `${sourceLayer.name} 副本`,
      visible: true,
      opacity: sourceLayer.opacity,
      blendMode: sourceLayer.blendMode,
      filters: { ...sourceLayer.filters } // 深拷贝滤镜设置
    };
    
    // 复制画布内容
    const duplicatedCanvas = document.createElement('canvas');
    duplicatedCanvas.width = sourceCanvas.width;
    duplicatedCanvas.height = sourceCanvas.height;
    const ctx = duplicatedCanvas.getContext('2d');
    ctx.drawImage(sourceCanvas, 0, 0);
    
    // 添加到图层列表和缓存中
    layers.splice(layerIndex + 1, 0, duplicatedLayer); // 插入到原图层后面
    layerCanvases[newLayerId] = duplicatedCanvas;
    
    return {
      layerIndex: layerIndex + 1,
      layerId: newLayerId
    };
  }
  
  // 移动图层内容
  function moveLayerContent(layerCanvas, dx, dy) {
    if (!layerCanvas) return false;
    
    // 创建临时画布
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = layerCanvas.width;
    tempCanvas.height = layerCanvas.height;
    const tempCtx = tempCanvas.getContext('2d');
    
    // 复制原画布内容
    tempCtx.drawImage(layerCanvas, 0, 0);
    
    // 清除原画布
    const ctx = layerCanvas.getContext('2d');
    ctx.clearRect(0, 0, layerCanvas.width, layerCanvas.height);
    
    // 在偏移位置绘制内容
    ctx.drawImage(tempCanvas, dx, dy);
    
    return true;
  }
  
  // 测试动作预设的执行函数
  export default function testAction(context) {
    const { layers, layerCanvases, updateLayerThumbnail, redrawCanvas } = context;
    
    console.log('执行测试动作预设...');
    
    try {
      // 确保有足够的图层
      if (layers.length < 3) {
        throw new Error('测试动作需要至少三个图层');
      }
      
      // 步骤1: 重命名三个图层
      layers[0].name = '底图';
      layers[1].name = '全屏水印Q1';
      layers[2].name = '全屏水印Q2';
      
      // 步骤2: 将图层三反转颜色
      const q2LayerId = layers[2].id;
      const q2Canvas = layerCanvases[q2LayerId];
      
      if (!applyInvertFilter(q2Canvas)) {
        throw new Error('无法对全屏水印Q2图层应用反相效果');
      }
      
      // 步骤3: 合并图层二和图层三
      const mergedLayer = mergeLayers(context, 1, 2);
      // 重命名为调整水印
      layers[mergedLayer.layerIndex].name = '调整水印';
      
      // 更新缩略图
      updateLayerThumbnail(mergedLayer.layerIndex);
      
      // 步骤4: 复制调整水印层
      const duplicatedLayer = duplicateLayer(context, mergedLayer.layerIndex);
      // 重命名为调整水印2
      layers[duplicatedLayer.layerIndex].name = '调整水印2';
      
      // 更新缩略图
      updateLayerThumbnail(duplicatedLayer.layerIndex);
      
      // 步骤5: 选择调整水印2执行反转颜色，并向左上偏移1像素
      const adjustLayer2Canvas = layerCanvases[duplicatedLayer.layerId];
      
      if (!applyInvertFilter(adjustLayer2Canvas)) {
        throw new Error('无法对调整水印2图层应用反相效果');
      }
      
      if (!moveLayerContent(adjustLayer2Canvas, -1, -1)) {
        throw new Error('无法对调整水印2图层进行位移');
      }
      
      // 更新缩略图
      updateLayerThumbnail(duplicatedLayer.layerIndex);
      
      // 步骤6: 合并调整水印和调整水印2
      const finalMergedLayer = mergeLayers(context, mergedLayer.layerIndex, duplicatedLayer.layerIndex);
      // 重命名为水印效果
      layers[finalMergedLayer.layerIndex].name = '水印效果';
      
      // 更新缩略图
      updateLayerThumbnail(finalMergedLayer.layerIndex);
      
      // 步骤7: 将水印效果的混合模式改为叠加
      layers[finalMergedLayer.layerIndex].blendMode = 'overlay';
      
      // 最终重绘画布
      redrawCanvas();
      
      console.log('测试动作预设执行完成');
      return true;
    } catch (error) {
      console.error('执行测试动作预设时出错:', error);
      return false;
    }
  } 